"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTheme = exports.getFonts = exports.getCore = void 0;
var _designTokens = _interopRequireDefault(require("@maersk-global/mds-design-tokens/maersk/light/web/json/design-tokens.json"));
//@ts-nocheck

const getFonts = () => {
  return _designTokens["default"] === null || _designTokens["default"] === void 0 ? void 0 : _designTokens["default"].brand;
};
exports.getFonts = getFonts;
const getCore = () => {
  return _designTokens["default"] === null || _designTokens["default"] === void 0 ? void 0 : _designTokens["default"].core;
};
exports.getCore = getCore;
const getTheme = () => {
  return _designTokens["default"] === null || _designTokens["default"] === void 0 ? void 0 : _designTokens["default"].theme;
};
exports.getTheme = getTheme;